(function() {
  function initializeSweetAlertModal() {
    var customTrigger = document.querySelector('[data-action="open-plesio-redirect-modal"]');

  if (customTrigger) {
    customTrigger.addEventListener('click', function(event) {
      event.preventDefault();

      var modalHtml =
      "<p>You are now leaving Lorea's website and will be redirected to Plesio Health, an independently operated third-party platform where you may consult with licensed nursing professionals.</p>" + 
       "<p>Please note the following:</p>" +
        "<ul>" +
         "<li>We do not control or guarantee the accuracy, relevance, timeliness, or completeness of the information provided by Plesio Health.</li>" +
         "<li>We are not responsible for the clinical advice or services you may receive during your consultation.</li>" +
         "<li>Any personal or health information you provide to Plesio Health is subject to that site's privacy policy and terms of use, which may differ from ours.</li>" +
        "</ul>" +
        "<p>By proceeding, you acknowledge and accept these conditions.</p>";

      Swal.fire({
        title: 'You Are Now Leaving Our Website',
        html: modalHtml, 
        showCancelButton: true,
        confirmButtonText: 'Continue',
        cancelButtonText: 'Cancel',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          // Redirect to an external URL opening a new tab
          const externalUrl = 'https://plesiohealth.com/';
          window.open(externalUrl, '_blank');
        }
      });
    });
  }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSweetAlertModal);
  } else {
    initializeSweetAlertModal();
  }
})();